module.exports = __webpack_public_path__ + "img/picto10.1f82b3c0.svg";